import imageCompression from "browser-image-compression";
import { api } from "./api";

// Convert HEIC/HEIF phone photos + compress large JPEGs, then upload. Returns "/api/files/..." URL.
export async function compressAndUpload(file) {
  let input = file;
  const isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name || "");
  if (isHeic) {
    const heic2any = (await import("heic2any")).default;
    const blob = await heic2any({ blob: file, toType: "image/jpeg", quality: 0.9 });
    const b = Array.isArray(blob) ? blob[0] : blob;
    input = new File([b], (file.name || "photo").replace(/\.(heic|heif)$/i, ".jpg"), { type: "image/jpeg" });
  }
  const compressed = await imageCompression(input, {
    maxWidthOrHeight: 1920,
    maxSizeMB: 1.6,
    useWebWorker: true,
    fileType: "image/jpeg",
  });
  const fd = new FormData();
  const name = (input.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
  fd.append("file", compressed, name);
  const r = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data.url;
}
